import type { Module } from 'vuex'
import IApiBaseService from '@/services/interfaces/IApiBase.service'
import {
  createBaseActions,
  createBaseMutations,
  createBaseState,
} from '@/store/modules/Base.module'
import { NotificationSubscription } from '@/classes/generated-models'
import { IBaseModuleState } from '@/store/interfaces/IBase.module'
import { NotificationService } from '@/services/Notification.service'
import type { IState } from '@/store'

export interface INotificationsState extends IBaseModuleState<NotificationSubscription, NotificationSubscription[]> {}

const notificationService: IApiBaseService<NotificationSubscription, NotificationSubscription[]> = new NotificationService()

export const Notifications: Module<INotificationsState, IState> = {
  namespaced: true,
  state: (): INotificationsState => ({
    ...createBaseState<NotificationSubscription, NotificationSubscription[]>(notificationService),
  }),
  mutations: {
    ...createBaseMutations<NotificationSubscription, NotificationSubscription[]>(),
  },
  actions: {
    ...createBaseActions<NotificationSubscription, NotificationSubscription[]>(),
  },
}
